import styled from "styled-components";

import { Card } from "@/components/molecules";
import { breakpoints } from "@/styles/breakpoints";

export const StyledInvoiceCard = styled(Card)`
    .contentWrapper {
        display: flex;
        min-height: 80px;

        .bodyWrapper {
            flex: 1;
        }
        .description {
            width: auto;
            margin-left: 15px;
            place-content: end;
        }
    }

    .beforeText {
        color: var(--color-error) !important;
    }
`;

export const StyledInvoicePrice = styled.div`
    font-size: var(--size-24);
    font-weight: var(--weight-600);
    color: var(--color-secondary);
    text-align: right;
    @media ${breakpoints.xs} {
        font-size: var(--size-20);
    }
`;
